import React from 'react'
import { useEffect, useState } from 'react';
import './FaultSecondPageCustom_Coral.css';

import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitialstates_coral';
import NoData_Coral from '../../Driveanalysis_Coral/NoData_Coral';
import COmpBiDirTest_Coral from './FaultSecondPageChartsBidirRender_Coral';
import ChartLoader_Coral from '../../Driveanalysis_Coral/ChartLoader_Coral';

export default function FaultSecondPageChartsBidir_Coral(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [defaultNav, setDefaultNav] = useState("BCS");
  const [dataMain, setDataMain] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "268px" }); //width: "565px",
  // #ffa344 #358696
  const [topping, setTopping] = useState("Fault")

  const [toCalculate, setToCalculate] = useState(0)

  const onRadioChange = e => {
    setTopping(e.target.value)
  }

  const responceDataNew = (data) => {
    const objArray = [];
    Object.keys(data).forEach(key => objArray.push({
      name: key,
      rating: data[key]
    }))

    const mainECU = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU", "BAS", "Cluster"];
    mainECU.forEach(element => {
      var index = objArray.findIndex(x => x.name == element);
      index === -1 && objArray.push({
        "name": element, "rating": { "value": 0 }
      })
    });

    const objArrayA = objArray.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
    const foodBar = objArrayA.find(item => item.name === defaultNav);
    setToCalculate(foodBar.rating.value);
  }

  const responceData = (data) => {
    let dataArray = [];

    // Total of all values
    let totalTime = data.reduce((acc, item) => acc + (item.NumOfTime?.value || 0), 0);
    let totalOcc = data.reduce((acc, item) => acc + (item.occ?.value || 0), 0);

    data.forEach((item) => {
      const signalName = item.key?.L4_Signal_Name?.toUpperCase() || 'UNKNOWN';

      const timeVal = item.NumOfTime?.value || 0;
      const occVal = item.occ?.value || 0;

      const male = totalTime > 0 ? (timeVal / totalTime) * 100 : 0;
      const female = totalOcc > 0 ? (occVal / totalOcc) * 100 : 0;

      dataArray.push({
        age: signalName,
        male: -male,
        female: female,
        orgLevalMale: timeVal.toString(),
        orgLevalFemale: occVal.toString(),
        signal_nm: item.key?.L4_Signal_Name,
        signal_desc: item.key?.Signal_value,
        signal_val: item.key?.Fault_Alarm_Value
      });
    });

    // Handle duplicates (same signal name with different fault values)
    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = `${dataArray[j].age}_${dataArray[j].signal_val}`;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = `${dataArray[i].age}_${dataArray[i].signal_val}`;
      }
    }

    // Sort by `male` value ascending
    dataArray.sort((a, b) => a.male - b.male);

    setDataMain(dataArray);
  };



  useEffect(() => {
    if (topping === "Fault") {
      fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/barFaultAnanysis', body: { selected: 'duration', startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceDataNew);
    } else {
      fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/barFaultAnanysisAlertCalculator', body: { selected: 'duration', startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceDataNew);
    }
    fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/vehicleLeval' + topping, body: { defaultNav: defaultNav, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceData);
  }, [topping, defaultNav, props, toCalculate])

  function getNavTab(e, name) {
    setDefaultNav(name);
  }

  return (
    <div className="col-md-12 col-lg-6 col-sm-12 mgt-2">
      <div className="v-title chartbox3">
        <div className="row">
          <div className="col-md-6 col-sm-6 col-lg-6">
            <div className="titlebg">Vehicle Level Fault</div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6" style={{ textAlign: 'end' }}>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Fault" value="Fault" checked={topping === "Fault"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio1">Fault</label>
            </div>
            {/* <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Alarm" value="Alarm" checked={topping === "Alarm"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio2">Alert</label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="DTC" value="DTC" checked={topping === "DTC"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio2">DTC</label>
            </div> */}
          </div>
        </div>
        <div className="chartHGT">
          <div className="mt-2 mb-2">
            <div className="mt-3">
              <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px" }}>
                <li className="nav-item">
                  <a className="nav-link active" data-bs-toggle="tab" href="#BCS" onClick={(e) => getNavTab(e, "BCS")}>BCS</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#MCU" onClick={(e) => getNavTab(e, "MCU")}>MCU</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#VCU" onClick={(e) => getNavTab(e, "VCU")}>VCU</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#DCDC" onClick={(e) => getNavTab(e, "DCDC")}>DCDC</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#OBC" onClick={(e) => getNavTab(e, "OBC")}>OBC</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#BMS" onClick={(e) => getNavTab(e, "BMS")}>BMS</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#BAS" onClick={(e) => getNavTab(e, "BAS")}>BAS</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="tab" href="#Cluster" onClick={(e) => getNavTab(e, "Cluster")}>Cluster</a>
                </li>
              </ul>
              <div className="tab-content">
                <div className='row' style={{ textAlign: 'right' }}>
                  <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                    <dt className="red" ></dt>
                    <dd>Time Duration (mins)</dd>
                    <dt className="yellow" style={{ marginLeft: "5px" }}></dt>
                    <dd>Occurrence</dd>
                  </dl>
                </div>
                <div id="BCS" className="tab-pane active"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader_Coral /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest_Coral dataMain={dataMain} id={"chartdivBCS"} /> :
                          <NoData_Coral />)
                      }
                    </div>
                  </div>
                </div>
                <div id="MCU" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader_Coral /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest_Coral dataMain={dataMain} id={"chartdivMCU"} /> :
                          <NoData_Coral />)
                      }
                    </div>
                  </div>
                </div>
                <div id="VCU" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader_Coral /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest_Coral dataMain={dataMain} id={"chartdivVCU"} /> :
                          <NoData_Coral />)
                      }
                    </div>
                  </div>
                </div>
                <div id="DCDC" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader_Coral /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest_Coral dataMain={dataMain} id={"chartdivDCDC"} /> :
                          <NoData_Coral />)
                      }
                    </div>
                  </div>
                </div>
                <div id="OBC" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader_Coral /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest_Coral dataMain={dataMain} id={"chartdivOBC"} /> :
                          <NoData_Coral />)
                      }
                    </div>
                  </div>
                </div>
                <div id="BMS" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader_Coral /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest_Coral dataMain={dataMain} id={"chartdivBMS"} /> :
                          <NoData_Coral />)
                      }
                    </div>
                  </div>
                </div>
                <div id="BAS" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader_Coral /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest_Coral dataMain={dataMain} id={"chartdivBAS"} /> :
                          <NoData_Coral />)
                      }
                    </div>
                  </div>
                </div>
                <div id="Cluster" className="container tab-pane fade"><br />
                  <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                    <div style={LineContainerBodyBD} >
                      {(isLoading) ? <ChartLoader_Coral /> :
                        (dataMain.length > 0 ?
                          <COmpBiDirTest_Coral dataMain={dataMain} id={"chartdivCluster"} /> :
                          <NoData_Coral />)
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
